<template>
  <div class="title">Отчет за {{ dateLabel }} [{{ appLogin }}]</div>
</template>

<script>
import dateLabel from '@/mixins/dateLabel'
import currentApplicationMixin from '../mixins/currentApplicationMixin'

export default {
  mixins: [dateLabel, currentApplicationMixin],
  computed: {
    dateLabel() {
      const { month, year } = this.getDateLabel()

      return `${month.text} ${year}`.trim().toLowerCase() // апрель 2021
    },
  },
}
</script>
